/**
 * Faz 9 vitrin metinleri (öneriler, yeniden alım zamanı, yapay zekâ görsel notu). Vitrin girişi
 * (`@zt/i18n/storefront`) yalnızca `storefront.*` gördüğü için `storefront.ar.ts` → `storefrontAr.ai` altına bağlanır.
 */
export const storefrontAiAr = {
  alsoBought: 'من اشترى هذا المنتج اشترى أيضًا',
  cartRecommendations: 'قد ترغب أيضًا في إضافة',
  replenishmentTitle: 'منتجات اقترب موعد إعادة شرائها',
  replenishmentLead: 'تواريخ تقديرية بناءً على طلباتك السابقة؛ ويمكنك إضافتها إلى السلة الآن إن شئت.',
  replenishmentDue: 'موعد إعادة الشراء التقديري: {{date}}',
  aiImage: 'صورة مُنشأة بالذكاء الاصطناعي',
  replenishmentOverdue: 'انقضى موعد إعادة الشراء التقديري ({{date}})',
  replenishmentBasis: {
    own: 'تشتريه تقريبًا كل {{days}} يومًا',
    typical: 'يُشترى هذا المنتج عادةً كل {{days}} يومًا',
  },
};
